import { DomeComponent, DomeManipulator, React } from '@lexriver/dome'
import css from './UserInMenu.m.scss'
import { UrlGenerator } from '../UrlGenerator'
import { Link } from './Link'
import { GlobalUser } from '../GlobalUser'

const filename = 'UserInMenu'

interface Attrs{

}

export class UserInMenu extends DomeComponent<Attrs>{
    refContainer! :HTMLDivElement
    //counter:number = 0
    render(){
        return <div class={css.userInMenu} ref={ref => this.refContainer = ref}></div>
    }

    afterRender(){
        //console.log(filename, 'GlobalUser.loggedInUserO=', GlobalUser.loggedInUserO.get(), 'GlobalUser.sessionIdO=', GlobalUser.sessionIdO.get())
        this.scheduleUpdate()
        GlobalUser.eventUserLoggedIn.subscribe(() => {
            if(DomeManipulator.isInDom(this.refContainer) == false) return {unsubscribe:true}
            this.scheduleUpdate()
        })

        GlobalUser.eventUserLoggedOut.subscribe(() => { //TODO: merge to one function?
            if(DomeManipulator.isInDom(this.refContainer) == false) return {unsubscribe:true}
            this.scheduleUpdate()
        })

        GlobalUser.loggedInUserO.eventOnChange.subscribe(() => {
            this.scheduleUpdate()
        })
    }

    async updateAsync(){
        //this.counter++
        await DomeManipulator.replaceAllChildrenAsync(this.refContainer, await GlobalUser.checkIfAnonymousAsync() ? this.renderAnonymous() : this.renderLoggedIn())
    }

    renderAnonymous(){
        return <>
        {/* <div>counter={this.counter}</div> */}
        <div class={css.userName}><span class="icon-user"></span>Гость</div>
        <div>
            <Link url={UrlGenerator.register}>регистрация</Link>
            {/* <br/> */}
            &nbsp;&nbsp;
            <Link url={UrlGenerator.login}>войти</Link>
        </div>
        </>
    }

    renderLoggedIn(){
        const user = GlobalUser.loggedInUserO.get()
        if(!user) {
            console.error('no user in global state when isLoggedIn==true')
            return <div>Error! please report!</div>
        }

        return <>
            {/* <div>counter={this.counter}</div> */}
            <div class={css.userName}><span class="icon-user"></span>{user.lastName} {user.firstName} {user.middleName}</div>
            <div>
                <Link url={UrlGenerator.profile}>кабинет</Link>
                &nbsp;
                <Link url={UrlGenerator.logout}>выход</Link>
            </div>
        </>
    }

}

